import React from 'react';

import WebaliasLink from '@/components/Link/WebaliasLink';
import { StrapiBanner } from '@/types/Banners';

import Container from '../Container';
import BannerCarousel from './Components/BannerCarousel';
import CarouselImage from './Components/BannerCarousel/CarouselImage';

interface BOBannerProps {
  data: StrapiBanner[];
}

const BOBanner = ({ data }: BOBannerProps) => {
  return (
    <div className={data.length > 1 ? 'v2-pb-7' : ''}>
      <Container className="v2-max-w-[1080px] v2-mx-auto">
        <BannerCarousel>
          {data?.map((banner, idx) => (
            <WebaliasLink target="_blank" href={banner.bannerLink || banner.pdfUrl || '#'} as={'a'} key={banner.id}>
              <CarouselImage
                tabletImage={banner.tabletImage}
                desktopImage={banner.desktopImage}
                mobileImage={banner.mobileImage}
                priority={idx === 0}
                loading={idx !== 0 ? 'lazy' : undefined}
              />
            </WebaliasLink>
          ))}
        </BannerCarousel>
      </Container>
    </div>
  );
};

export default BOBanner;
